import request from '@/utils/request';

/**
 *
 * 油管理
 *
 **/

// 查询油列表接口（支持分页）
export const getOilsByPage = (params) => {
  return request({
    url: '/oils/page',
    method: 'get',
    params,
  });
};

// 根据 ID 查询油接口
export const getOilById = (id) => {
  return request({
    url: `/oils/${id}`,
    method: 'get',
  });
};

// 删除油接口
export const deleteOil = (id) => {
  return request({
    url: `/oils/${id}`,
    method: 'delete',
  });
};

// 修改油接口
export const updateOil = (id, params) => {
  return request({
    url: `/oils/${id}`,
    method: 'put',
    data: { ...params },
  });
};

// 新增油接口
export const createOil = (params) => {
  return request({
    url: '/oils',
    method: 'post',
    data: { ...params },
  });
};

// 启用/禁用油接口
export const enableOrDisableOil = (params) => {
  return request({
    url: `/oils/status/${params.status}`,
    method: 'post',
    params: { id: params.id },
  });
};